import { Tag } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import { config } from '../../constant';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import {
  trendLabelTranslationNew,
  predictionsLegendsTranslation
} from '../../../Utils/Adapter/translationAdapter';

const PieRose = (props) => {
  const [option, setOption] = useState(getInitialOption(props.selectedThemeing, props.graphprops));
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);

  const getData = async () => {
    let json = [];
    let { graphprops } = props;
    let errorInAPI = false;
    let noDataInDB = false;

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }

    if ((json && json.message) || (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)) {
      if (json.message) {
        errorInAPI = true;
      } else if (json.length === 0) {
        noDataInDB = true;
      }
    } else {
      if (json && Array.isArray(json)) {
        let newOption = cloneDeep(option);
        let legend = {
          left: 'center',
          textStyle: {
            color: props.selectedThemeing === 'lightTheme' ? 'black' : 'white',
            fontSize: 18,
            fontWeight: 'bold'
          },
          data: json
        };

        let series = await trendLabelTranslationNew(json, props.translationCache);
        let legends = await predictionsLegendsTranslation(legend, props.translationCache);

        newOption.series[0].data = series;
        newOption.legend = legends;
        setOption(newOption);
        setRefreshDateTime(moment());
      }
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  return (
    <Fragment>
      {props.graphprops && props.graphprops.checked ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB || errorInAPI ? (
        noDataInDB ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          option={option}
          style={{ height: '90%', width: '100%' }}
          className="react_for_echarts"
        />
      )}
    </Fragment>
  );
};

const getInitialOption = (theme, graphprops) => {
  let option = {
    title: {
      left: 'center'
    },
    tooltip: {
      trigger: 'item',
      formatter: graphprops && graphprops[graphprops.graph] && graphprops[graphprops.graph].ResponseType === 'Show Value' ? '{b} : {c}' : '{b} : {d}%'
    },
    label: {
      color: theme === 'lightTheme' ? 'black' : 'white',
      fontWeight: 'bold',
      fontSize: 14
    },
    textStyle: {
      color: theme === 'lightTheme' ? 'black' : 'white',
      fontWeight: 'bold',
      fontSize: 18
    },
    legend: {
      left: 'center',
      textStyle: {
        color: theme === 'lightTheme' ? 'black' : 'white'
      },
      data: []
    },
    toolbox: {
      showTitle: false,
      itemSize: 25,
      feature: {
        saveAsImage: {
          title: 'download',
          backgroundColor: theme === 'lightTheme' ? 'black' : 'white',
          name: graphprops.title,
          iconStyle: {
            borderColor: '#8c8c8c',
            borderWidth: 2
          }
        }
      }
    },
    series: [
      {
        type: 'pie',
        radius: '65%',
        center: ['52%', '50%'],
        roseType: 'area',
        selectedMode: 'single',
        itemStyle: {
          borderRadius: 8
        }
      }
    ]
  };
  return option;
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(PieRose);